import {consentChanged, getConsentForGV} from "@otto-ec/eprivacy-cmp";

class SqrlConsentBanner {
    constructor(public isEnabled: boolean = false) {
        this.update();
    }

    async update() {
        const ottot: boolean = await getConsentForGV("OTTOT");
        const otton: boolean = await getConsentForGV("OTTON");
        this.isEnabled ||= ottot || otton || false;
    }

    listenOnConsentChange() {
        consentChanged.on(async () => await this.update());
    }
}

export const sqrlConsentBanner = new SqrlConsentBanner();
